import {
    lazyOpenBookingDashboard,
    lazyOpenBookingCompose,
    lazyEditBookingMeeting,
    lazyOpenBookingPage,
    lazyOpenMeetingTypePage,
    lazyOpenMeetingDetailsPage,
} from 'bookwithme-routes';

export interface EditMeetingTypeParameters {
    meetingTypeId: string;
}

export interface OpenBookingPageParameters {
    bookingMailbox: string;
}

export interface OpenMeetingTypeParameters {
    bookingMailbox: string;
    meetingTypeId: string;
}

export interface OpenMeetingDetailsPageParameters {
    bookingMailbox: string;
    bookingId: string;
}

export async function openBookingDashboardRouteHandler() {
    return lazyOpenBookingDashboard.importAndExecute(null, null);
}

export async function openBookingComposeRouteHandler() {
    return lazyOpenBookingCompose.importAndExecute();
}

export async function editBookingMeetingRouteHandler(parameters: EditMeetingTypeParameters) {
    return lazyEditBookingMeeting.importAndExecute(parameters.meetingTypeId);
}

export async function openBookingPageRouteHandler(parameters: OpenBookingPageParameters) {
    return lazyOpenBookingPage.importAndExecute(parameters.bookingMailbox);
}

export async function openMeetingTypePageRouteHandler(parameters: OpenMeetingTypeParameters) {
    return lazyOpenMeetingTypePage.importAndExecute(
        parameters.bookingMailbox,
        parameters.meetingTypeId
    );
}

export async function openMeetingDetailsPageRouteHandler(
    parameters: OpenMeetingDetailsPageParameters
) {
    return lazyOpenMeetingDetailsPage.importAndExecute(
        parameters.bookingMailbox,
        parameters.bookingId
    );
}
